<template>

    <div>
        <slot></slot>
    </div>

</template>

<script>
    
    import split from 'split.js';

    export default {
        name: "splitter",
        props: ["fullheight", "options"],
        data() {
            return {
            }
        },
        methods: {
        },
        components: {
        },
        mounted() {
            var $elements = [];
            for (var child of this.$children) {
                $elements.push(child.$el);
            }
            split($elements, this.options)

            if (this.fullheight) {
                var self = this;
                function fixHeight() {
                    console.log(self, $(self.$el).offset());
                    $(self.$el).height($(window).height() - $(self.$el).offset().top);
                }
                $(window).resize(fixHeight);
                window.setTimeout(fixHeight, 10);
            }
        }
    }
</script>

<style>
    .gutter {
        background-color: #eee;

        background-repeat: no-repeat;
        background-position: 50%;
    }

    .gutter.gutter-horizontal {
        background-image:  url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');
        cursor: ew-resize;
    }

    .gutter.gutter-vertical {
        background-image:  url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');
        cursor: ns-resize;
}
</style>


// WEBPACK FOOTER //
// Splitter.vue?0032c716